import React, { useState } from 'react';
import { View, Text, TouchableOpacity, ScrollView, StyleSheet, Dimensions, Modal } from 'react-native';
import { useTheme } from '../contexts/ThemeContext';
import { useNavigation, useRoute } from '@react-navigation/native';

const Sidebar = ({ isOpen, onClose }) => {
  const { colors, isDarkMode, toggleTheme } = useTheme();
  const navigation = useNavigation();
  let currentRouteName = '';
  try {
    const route = useRoute();
    currentRouteName = route?.name || '';
  } catch (e) {
    // In case used outside NavigationContainer
  }
  const [expandedSections, setExpandedSections] = useState({
    taxCalculators: true,
    investmentTools: true,
    loanCalculators: true,
  });

  // Get screen dimensions for responsive behavior
  const screenWidth = Dimensions.get('window').width;
  const isMobile = screenWidth < 768;

  const toggleSection = (section) => {
    setExpandedSections(prev => {
      const newState = {
        ...prev,
        [section]: !prev[section]
      };
      console.log('Toggling section:', section, 'New state:', newState);
      return newState;
    });
  };

  const navigateToScreen = (screenName) => {
    navigation.navigate(screenName);
    if (isMobile) {
      onClose && onClose();
    }
  };

  const menuItems = [
    {
      id: 'taxCalculators',
      title: 'TAX CALCULATORS',
      icon: '📊',
      items: [
        { name: 'Income Tax Calculator', screen: 'IncomeTaxCalculator', icon: '💰'},
        { name: 'Salary Calculator', screen: 'SalaryCalculator', icon: '💼' },
        { name: 'GST Calculator', screen: 'GSTCalculator', icon: '🧾' },
        { name: 'TDS Calculator', screen: 'TDSCalculator', icon: '📋' },
        { name: 'Advance Tax Calculator', screen: 'AdvanceTaxCalculator', icon: '⏰' },
        { name: 'Capital Gains Calculator', screen: 'CapitalGainsCalculator', icon: '📈' },
        { name: 'HRA Calculator', screen: 'HRACalculator', icon: '🏠' },
        { name: 'Gratuity Calculator', screen: 'GratuityCalculator', icon: '💰' },
      ]
    },
    {
      id: 'investmentTools',
      title: 'INVESTMENT TOOLS',
      icon: '📈',
      items: [
        { name: 'Simple Interest Calculator', screen: 'SimpleInterestCalculator', icon: '💰' },
        { name: 'SIP Calculator', screen: 'SIPCalculator', icon: '💹' },
        { name: 'Step-Up SIP Calculator', screen: 'StepUpSIPCalculator', icon: '📈' },
        { name: 'Retirement Calculator', screen: 'RetirementCalculator', icon: '👴' },
        { name: 'SWP Calculator', screen: 'SWPCalculator', icon: '📉' },
        { name: 'Mutual Fund Returns Calculator', screen: 'MutualFundReturnsCalculator', icon: '📊' },
        { name: 'FD Calculator', screen: 'FDCalculator', icon: '🏦' },
        { name: 'RD Calculator', screen: 'RDCalculator', icon: '💳' },
        { name: 'PPF Calculator', screen: 'PPFCalculator', icon: '🔒' },
        { name: 'PF Calculator', screen: 'PFCalculator', icon: '💼' },
        { name: 'NSC Calculator', screen: 'NSCCalculator', icon: '🏦' },
        { name: 'Compound Interest Calculator', screen: 'CompoundInterestCalculator', icon: '🧮' },
        { name: 'APY Calculator', screen: 'APYCalculator', icon: '📈' },
        { name: 'CAGR Calculator', screen: 'CAGRCalculator', icon: '📊' },
        { name: 'SSY Calculator', screen: 'SSYCalculator', icon: '👧' },
        { name: 'NPS Calculator', screen: 'NPSCalculator', icon: '📈' },
        { name: 'Lumpsum Calculator', screen: 'LumpsumCalculator', icon: '💎' },
        { name: 'Brokerage Calculator', screen: 'BrokerageCalculator', icon: '💸' },
        { name: 'Margin Calculator', screen: 'MarginCalculator', icon: '🧮' },
        { name: 'Inflation Calculator', screen: 'InflationCalculator', icon: '📈' },
        { name: 'Post Office MIS Calculator', screen: 'PostOfficeMISCalculator', icon: '🏤' },
        { name: 'SCSS Calculator', screen: 'SCSSCalculator', icon: '👴' },
        { name: 'Stock Average Calculator', screen: 'StockAverageCalculator', icon: '📊' },
        { name: 'XIRR Calculator', screen: 'XIRRCalculator', icon: '📈' },
      ]
    },
    {
      id: 'loanCalculators',
      title: 'LOAN CALCULATORS',
      icon: '🏦',
      items: [
        { name: 'EMI Calculator', screen: 'EMICalculator', icon: '🏠' },
        { name: 'Home Loan EMI Calculator', screen: 'HomeLoanEMICalculator', icon: '🏡' },
        { name: 'Car Loan EMI Calculator', screen: 'CarLoanEMICalculator', icon: '🚗' },
        { name: 'Personal Loan Calculator', screen: 'PersonalLoanEMICalculator', icon: '👤' },
        { name: 'Business Loan Calculator', screen: 'BusinessLoanEMICalculator', icon: '💼' },
        { name: 'Down Payment Calculator', screen: 'DownPaymentCalculator', icon: '💰' },
        { name: 'Flat vs Reducing Rate Calculator', screen: 'FlatVsReducingRateCalculator', icon: '📉' },
      ]
    }
  ];

  const styles = StyleSheet.create({
    sidebar: {
      width: 280,
      height: '100%',
      backgroundColor: colors.surface,
      borderRightWidth: 1,
      borderRightColor: colors.border,
      paddingTop: 20,
    },
    mobileSidebar: {
      position: 'absolute',
      left: 0,
      top: 0,
      width: 280,
      height: '100%',
      backgroundColor: colors.surface,
      borderRightWidth: 1,
      borderRightColor: colors.border,
      paddingTop: 20,
      zIndex: 1000,
      elevation: 10,
      shadowColor: '#000',
      shadowOffset: {
        width: 2,
        height: 0,
      },
      shadowOpacity: 0.25,
      shadowRadius: 3.84,
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      zIndex: 999,
    },
    header: {
      paddingHorizontal: 20,
      paddingBottom: 20,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
    },
    closeButton: {
      padding: 8,
      borderRadius: 20,
      backgroundColor: colors.border,
    },
    closeButtonText: {
      fontSize: 16,
      color: colors.text,
      fontWeight: 'bold',
    },
    logo: {
      fontSize: 18,
      fontWeight: 'bold',
      color: colors.text,
      marginBottom: 5,
    },
    tagline: {
      fontSize: 12,
      color: colors.textSecondary,
    },
    themeToggle: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 20,
      paddingVertical: 15,
      borderBottomWidth: 1,
      borderBottomColor: colors.border,
    },
    themeText: {
      fontSize: 14,
      color: colors.text,
      fontWeight: '500',
    },
    toggleButton: {
      width: 50,
      height: 26,
      borderRadius: 13,
      backgroundColor: isDarkMode ? colors.primary : colors.border,
      justifyContent: 'center',
      paddingHorizontal: 2,
    },
    toggleCircle: {
      width: 22,
      height: 22,
      borderRadius: 11,
      backgroundColor: colors.background,
      alignSelf: isDarkMode ? 'flex-end' : 'flex-start',
    },
    menuSection: {
      paddingVertical: 10,
    },
    sectionHeader: {
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'space-between',
      paddingHorizontal: 20,
      paddingVertical: 12,
      backgroundColor: colors.background,
    },
    sectionTitle: {
      fontSize: 12,
      fontWeight: '600',
      color: colors.textSecondary,
      letterSpacing: 0.5,
    },
    expandIcon: {
      fontSize: 12,
      color: colors.textSecondary,
    },
    menuItem: {
      flexDirection: 'row',
      alignItems: 'center',
      paddingHorizontal: 20,
      paddingVertical: 12,
      marginHorizontal: 10,
      borderRadius: 8,
    },
    activeMenuItem: {
      backgroundColor: colors.primary + '15',
      borderLeftWidth: 3,
      borderLeftColor: colors.primary,
    },
    menuIcon: {
      fontSize: 16,
      marginRight: 12,
      width: 20,
    },
    menuText: {
      fontSize: 14,
      color: colors.text,
      flex: 1,
    },
    activeMenuText: {
      color: colors.primary,
      fontWeight: '500',
    },
  });

  return (
    <>
      {isMobile ? (
        // Mobile: Show sidebar as modal overlay
        <Modal
          visible={isOpen}
          transparent={true}
          animationType="slide"
          onRequestClose={onClose}
        >
          <View style={styles.overlay}>
            <TouchableOpacity 
              style={styles.overlay} 
              activeOpacity={1} 
              onPress={onClose}
            />
            <View style={styles.mobileSidebar}>
              <View style={styles.header}>
                <Text style={styles.logo}>Calculators</Text>
                <TouchableOpacity onPress={onClose} style={styles.closeButton}>
                  <Text style={styles.closeButtonText}>✕</Text>
                </TouchableOpacity>
              </View>

              <ScrollView showsVerticalScrollIndicator={false}>
                {menuItems.map((section) => (
                  <View key={section.id} style={styles.menuSection}>
                    <TouchableOpacity 
                      style={styles.sectionHeader}
                      onPress={() => toggleSection(section.id)}
                    >
                      <Text style={styles.sectionTitle}>{section.title}</Text>
                      <Text style={styles.expandIcon}>
                        {expandedSections[section.id] ? '▼' : '▶'}
                      </Text>
                    </TouchableOpacity>
                    
                    {expandedSections[section.id] && section.items.map((item) => {
                      const isActive = item.screen === currentRouteName;
                      return (
                        <TouchableOpacity
                          key={item.name}
                          style={[
                            styles.menuItem,
                            isActive && styles.activeMenuItem
                          ]}
                          onPress={() => navigateToScreen(item.screen)}
                        >
                          <Text style={styles.menuIcon}>{item.icon}</Text>
                          <Text style={[
                            styles.menuText,
                            isActive && styles.activeMenuText
                          ]}>
                            {item.name}
                          </Text>
                        </TouchableOpacity>
                      );
                    })}
                  </View>
                ))}
              </ScrollView>
            </View>
          </View>
        </Modal>
      ) : (
        // Desktop: Show sidebar normally
        <View style={styles.sidebar}>
          <View style={styles.header}>
            <Text style={styles.logo}>Calculators</Text>
            {onClose && (
              <TouchableOpacity onPress={onClose} style={styles.closeButton}>
                <Text style={styles.closeButtonText}>✕</Text>
              </TouchableOpacity>
            )}
          </View>

          <ScrollView showsVerticalScrollIndicator={false}>
            {menuItems.map((section) => (
              <View key={section.id} style={styles.menuSection}>
                <TouchableOpacity 
                  style={styles.sectionHeader}
                  onPress={() => toggleSection(section.id)}
                >
                  <Text style={styles.sectionTitle}>{section.title}</Text>
                  <Text style={styles.expandIcon}>
                    {expandedSections[section.id] ? '▼' : '▶'}
                  </Text>
                </TouchableOpacity>
                
                {expandedSections[section.id] && section.items.map((item) => {
                  const isActive = item.screen === currentRouteName;
                  return (
                    <TouchableOpacity
                      key={item.name}
                      style={[
                        styles.menuItem,
                        isActive && styles.activeMenuItem
                      ]}
                      onPress={() => navigateToScreen(item.screen)}
                    >
                      <Text style={styles.menuIcon}>{item.icon}</Text>
                      <Text style={[
                        styles.menuText,
                        isActive && styles.activeMenuText
                      ]}>
                        {item.name}
                      </Text>
                    </TouchableOpacity>
                  );
                })}
              </View>
            ))}
          </ScrollView>
        </View>
      )}
    </>
  );
};

export default Sidebar;
